
(function(){
  if(window.ssAgentReply)return;
  var MAX=1400;
  var FONTS="@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100 1000;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu6-K6z9mXgjU0.woff2) format('woff2');\n  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100 1000;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/dmsans/v17/rP2Yp2ywxg089UriI5-g4vlH9VoD8Cmcqbu0-K6z9mXg.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}";
  var BLOCK="html|head|body|style|script|div|section|article|aside|header|footer|main|nav|table|thead|tbody|tfoot|tr|td|th|caption|colgroup|ul|ol|li|dl|dt|dd|p|h[1-6]|details|summary|figure|figcaption|blockquote|svg|pre|hr|form|fieldset|canvas|center|img|picture|video|audio|iframe|button|label|input|select|textarea|progress|meter|template";
  var SHADOW=":host{display:block;--ink:var(--ss-text,#1a1a1f);--muted:var(--ss-text-subtle,#6b6b78);--line:var(--ss-border,#e0ddd8);--accent:var(--ss-brand-text,#5a5ae6);--surface:var(--ss-surface,#fff);--soft:var(--ss-surface-muted,#f3f2ee);--good:var(--ss-success-text,#1f7a4d);--bad:var(--ss-danger-text,#b42318)}\n*,*::before,*::after{box-sizing:border-box}\n.ss-r{color:var(--ink);overflow-wrap:anywhere}\n.ss-r>:first-child{margin-top:0}.ss-r>:last-child{margin-bottom:0}\nh1,h2,h3,h4,h5,h6{font-weight:650;line-height:1.25;letter-spacing:-.005em;margin:.85em 0 .35em}\nh1{font-size:1.22em}h2{font-size:1.12em}h3{font-size:1.02em}h4,h5,h6{font-size:.92em;color:var(--muted)}\np{margin:.5em 0}\nul,ol{margin:.45em 0;padding-left:1.25em}li{margin:.2em 0}li::marker{color:var(--muted)}\ndl{margin:.5em 0}dt{font-weight:600}dd{margin:0 0 .4em}\na{color:var(--accent);text-decoration:underline;text-underline-offset:2px}\nstrong,b{font-weight:650}small{color:var(--muted)}mark{background:var(--soft);color:inherit;border-radius:3px;padding:0 .15em}\nhr{border:0;border-top:1px solid var(--line);margin:.9em 0}\nblockquote{margin:.6em 0;padding:.05em 0 .05em .85em;border-left:3px solid var(--accent);color:var(--muted)}\ncode,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;font-size:.88em}\ncode,kbd{background:var(--soft);border-radius:5px;padding:.08em .32em}\npre{background:var(--soft);border-radius:10px;padding:.65em .8em;margin:.55em 0;white-space:pre-wrap}pre code{background:none;padding:0}\ntable{border-collapse:collapse;width:100%;font-size:.95em;margin:.55em 0}\nth,td{text-align:left;vertical-align:top;padding:.4em .6em .4em 0;border-bottom:1px solid var(--line)}\nth{font-weight:600;color:var(--muted);font-size:.88em}\nimg,svg{max-width:100%}img{height:auto}\ndetails{margin:.5em 0}summary{cursor:pointer;color:var(--accent)}\nfigure{margin:.6em 0}figcaption{color:var(--muted);font-size:.9em;margin-top:.3em}";
  // A fence (three backticks, a language, lines, three backticks): html or svg
  // is a card, anything else is code.
  var FENCE=/\x60\x60\x60([\w+-]*)[ \t]*\r?\n([\s\S]*?)\r?\n?\x60\x60\x60/g;
  var HTMLFENCE=/\x60\x60\x60html[ \t]*\r?\n([\s\S]*?)\r?\n?\x60\x60\x60/gi;
  var START=new RegExp('^[ \\t]*<(?:!doctype\\b|!--|(?:'+BLOCK+')\\b)','i');
  var TAG=/<(\/?)([a-zA-Z][\w:-]*)((?:[^>"']|"[^"]*"|'[^']*')*)>/y;
  var VOID=/^(?:area|base|br|col|embed|hr|img|input|link|meta|param|source|track|wbr)$/;
  var RAWTEXT=/^(?:script|style|textarea|title)$/;
  var seq=0,frames={};
  function mk(tag,cls){var e=document.createElement(tag);if(cls)e.className=cls;return e}
  function txt(t){return document.createTextNode(t)}
  function ent(t){return String(t).replace(/&nbsp;/g,' ').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#39;/g,"'").replace(/&amp;/g,'&')}

  // ---- Frames ---------------------------------------------------------------
  // A card's document: a light sheet, readable type, nothing fixed-width, the
  // thread's colours as variables, and the height reporter. A full document
  // from the model is kept whole and only gets the reporter.
  var LIGHT=':root{color-scheme:light;--ink:#1a1a1f;--muted:#6b6b78;--line:#e0ddd8;--accent:#5a5ae6;--surface:#fff;--soft:#f3f2ee;--good:#1f7a4d;--bad:#b42318;--font:-apple-system,BlinkMacSystemFont,"Segoe UI",Inter,Roboto,Helvetica,Arial,sans-serif}';
  var BASE='*,*::before,*::after{box-sizing:border-box}img,svg,video,canvas,table{max-width:100%}table{border-collapse:collapse}th,td{text-align:left;padding:6px 10px;border-bottom:1px solid var(--line)}a{color:var(--accent)}h1,h2,h3{line-height:1.25;margin:.25em 0 .45em}p{margin:.45em 0}ul,ol{margin:.4em 0;padding-left:1.3em}';
  var HEAD='<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base target="_blank"><style>'+LIGHT+'html,body{margin:0;background:#fff;color:var(--ink)}body{font:16px/1.5 var(--font);padding:14px 16px}'+BASE+'h1{font-size:1.5rem}h2{font-size:1.25rem}h3{font-size:1.05rem}</style></head><body>';
  function reporter(id){
    return '<script>(function(){var id='+JSON.stringify(id)+';function send(){var b=document.body;if(!b)return;var s=getComputedStyle(b);var h=b.getBoundingClientRect().height+(parseFloat(s.marginTop)||0)+(parseFloat(s.marginBottom)||0);parent.postMessage({ssAgentBlock:id,height:h},"*")}if(window.ResizeObserver&&document.body)new ResizeObserver(send).observe(document.body);window.addEventListener("load",send);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(send);setTimeout(send,50);setTimeout(send,400);send()})()<\/script>';
  }
  function whole(html,id){
    var doc=html.replace(/<!doctype[^>]*>/i,'');
    // No <base> of its own → links leave the frame in a new tab, like ours.
    if(!/<base\s/i.test(doc))doc=doc.replace(/<head([^>]*)>/i,'<head$1><base target="_blank">');
    return /<\/body>/i.test(doc)?doc.replace(/<\/body>/i,reporter(id)+'</body>'):doc+reporter(id);
  }
  function srcdoc(html,id){
    return /<html[\s>]/i.test(html)?whole(html,id):HEAD+html+reporter(id)+'</body></html>';
  }
  // The page's own look, read where the frame sits: its ink and type from the
  // element around it, the rest from the theme's tokens.
  function look(f){
    var g=window.getComputedStyle;if(!g)return LIGHT;
    var root=g(document.documentElement),here=f.isConnected?g(f):root;
    function v(n,d){var x=root.getPropertyValue(n);return x&&x.trim()||d}
    var dark=/dark/.test(root.colorScheme||'')&&!/light/.test(root.colorScheme||'');
    var lh=here.lineHeight&&here.lineHeight!=='normal'?here.lineHeight:'1.5';
    return ':root{color-scheme:'+(dark?'dark':'light')+';--ink:'+(here.color||v('--ss-text','#1a1a1f'))+';--muted:'+v('--ss-text-subtle','#6b6b78')+';--line:'+v('--ss-border','#e0ddd8')+';--accent:'+v('--ss-brand-text','#5a5ae6')+';--surface:'+v('--ss-surface','#fff')+';--soft:'+v('--ss-surface-muted','#f3f2ee')+';--good:'+v('--ss-success-text','#1f7a4d')+';--bad:'+v('--ss-danger-text','#b42318')+';--font:'+(here.fontFamily||'system-ui,sans-serif')+'}html,body{margin:0;padding:0;background:transparent;color:var(--ink)}body{display:flow-root;font-family:var(--font);font-size:'+(here.fontSize||'16px')+';line-height:'+lh+'}h1{font-size:1.3em}h2{font-size:1.15em}h3{font-size:1.04em}body>:first-child{margin-top:0}body>:last-child{margin-bottom:0}';
  }
  function flowDoc(html,id,css){
    if(/<html[\s>]/i.test(html))return whole(html,id);
    return '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base target="_blank"><style>'+FONTS+css+BASE+'</style></head><body>'+html+reporter(id)+'</body></html>';
  }
  window.addEventListener('message',function(e){
    var d=e.data;
    if(!d||typeof d!=='object'||typeof d.ssAgentBlock!=='string')return;
    var x=frames[d.ssAgentBlock];
    if(!x||e.source!==x.f.contentWindow)return;
    var h=Number(d.height);
    if(!isFinite(h))return;
    x.f.style.height=Math.max(x.min,Math.min(MAX,Math.ceil(h)))+'px';
  });
  function frame(cls,min,title){
    var id='b'+(++seq);
    var wrap=mk('div',cls);
    var f=mk('iframe');
    f.setAttribute('sandbox','allow-scripts allow-popups allow-popups-to-escape-sandbox');
    f.setAttribute('referrerpolicy','no-referrer');
    // A flow frame starts 0px tall, which a lazy frame may never count as seen.
    if(min>8)f.setAttribute('loading','lazy');
    f.title=title;
    frames[id]={f:f,min:min};
    wrap.appendChild(f);
    return {id:id,wrap:wrap,f:f};
  }
  function block(html){
    var x=frame('ss-agent-block',40,'Visual reply');
    x.f.srcdoc=srcdoc(html,x.id);
    return x.wrap;
  }
  // A flow frame takes its look from where it lands, so its document is written
  // once the row is in the page (the callers append it in the same task).
  function flow(html){
    var x=frame('ss-agent-flow',8,'Reply');
    var tries=0;
    function go(){
      if(!x.f.isConnected&&tries++<20){(window.requestAnimationFrame||setTimeout)(go);return}
      x.f.srcdoc=flowDoc(html,x.id,look(x.f));
    }
    Promise.resolve().then(go);
    return x.wrap;
  }

  // ---- Inline HTML ------------------------------------------------------------
  // HTML that only shows something is drawn in the page, in a shadow root, after
  // an allowlist has cleaned it. Anything that has to run goes to a frame.
  var RUNS=/<(?:script|iframe|frame|form|input|button|select|textarea|canvas|video|audio|object|embed)\b|<html[\s>]/i;
  function set(words){var o={};words.split(' ').forEach(function(w){o[w]=1});return o}
  var SVG=set('svg g path rect circle ellipse line polyline polygon text tspan defs lineargradient radialgradient stop title desc clippath marker');
  var KEEP=set('div span p h1 h2 h3 h4 h5 h6 ul ol li dl dt dd table thead tbody tfoot tr th td caption colgroup col strong b em i u s del ins mark small sub sup code pre kbd samp var q cite abbr dfn time blockquote hr br wbr a details summary figure figcaption section article header footer aside nav main address center style img progress meter ruby rt rp bdi bdo data svg g path rect circle ellipse line polyline polygon text tspan defs lineargradient radialgradient stop title desc clippath marker');
  var DROP=set('script noscript template iframe frame frameset object embed applet link meta base head form input button select option optgroup textarea output canvas video audio source track use foreignobject image feimage filter animate animatemotion animatetransform set pattern mask math portal slot dialog');
  var GLOBAL=/^(?:class|id|title|lang|dir|role|style|hidden|aria-[\w-]+|data-[\w-]+)$/;
  var PER={a:/^href$/,td:/^(?:colspan|rowspan|headers|scope|align|valign)$/,th:/^(?:colspan|rowspan|headers|scope|align|valign|abbr)$/,col:/^span$/,colgroup:/^span$/,ol:/^(?:start|reversed|type)$/,ul:/^type$/,li:/^value$/,time:/^datetime$/,data:/^value$/,details:/^open$/,progress:/^(?:value|max)$/,meter:/^(?:value|max|min|low|high|optimum)$/,img:/^(?:src|alt|width|height)$/,table:/^align$/};
  var SVGATTR=/^(?:viewbox|xmlns|width|height|x|y|x1|y1|x2|y2|cx|cy|r|rx|ry|fx|fy|d|points|fill|fill-opacity|fill-rule|clip-rule|stroke|stroke-width|stroke-linecap|stroke-linejoin|stroke-dasharray|stroke-dashoffset|stroke-opacity|stroke-miterlimit|opacity|transform|text-anchor|dominant-baseline|alignment-baseline|baseline-shift|font-size|font-weight|font-family|font-style|letter-spacing|word-spacing|text-decoration|offset|stop-color|stop-opacity|gradientunits|gradienttransform|spreadmethod|preserveaspectratio|clip-path|clippathunits|marker-start|marker-mid|marker-end|markerwidth|markerheight|refx|refy|orient|markerunits|dx|dy|rotate|textlength|lengthadjust|vector-effect|shape-rendering|paint-order|display|visibility|pathlength)$/;
  // A URL in CSS is the one way a stylesheet reaches the network (a tracking
  // pixel that knows who read the reply); only a reference inside the reply, url(#id),
  // stays. :host would let the reply restyle the element it sits in. Escapes are
  // how a filter is walked around, so a stylesheet with a backslash is dropped.
  function cleanCss(t){
    t=String(t).replace(/\/\*[\s\S]*?\*\//g,'').replace(/@import[^;]*;?/gi,'')
      .replace(/url\s*\(\s*(?:"[^"]*"|'[^']*'|[^)]*)\)/gi,function(m){return /^url\s*\(\s*["']?#[\w-]+["']?\s*\)$/i.test(m)?m:'none'});
    return /\\|@import|@font-face|@namespace|url\s*\(\s*[^#\s"']|image-set|\bsrc\s*\(|:host|expression\s*\(|-moz-binding|behavior\s*:|javascript:/i.test(t)?'':t;
  }
  function attrOk(tag,name,v){
    if(/^on/.test(name)||/^(?:xmlns|xlink):/.test(name))return false;
    if(/url\s*\(/i.test(v)&&!/^\s*url\(\s*["']?#[\w-]+["']?\s*\)\s*$/i.test(v))return false;
    if(name==='href')return tag==='a'&&/^\s*(?:https?:\/\/|mailto:)/i.test(v);
    if(name==='src')return tag==='img'&&/^\s*data:image\/(?:png|jpe?g|gif|webp|svg\+xml)[;,]/i.test(v);
    if(/^\s*(?:javascript|vbscript|data):/i.test(v))return false;
    if(GLOBAL.test(name))return true;
    if(PER[tag]&&PER[tag].test(name))return true;
    return !!SVG[tag]&&SVGATTR.test(name);
  }
  function clean(parent){
    var kids=[],c=parent.firstChild;
    while(c){kids.push(c);c=c.nextSibling}
    for(var i=0;i<kids.length;i++){
      var n=kids[i];
      if(n.nodeType===3)continue;
      if(n.nodeType!==1){parent.removeChild(n);continue}
      var tag=String(n.localName||n.nodeName).toLowerCase();
      if(DROP[tag]){parent.removeChild(n);continue}
      // Anything else unknown gives up its tag and keeps its words.
      if(!KEEP[tag]){clean(n);while(n.firstChild)parent.insertBefore(n.firstChild,n);parent.removeChild(n);continue}
      if(tag==='style'){var css=cleanCss(n.textContent);if(css)n.textContent=css;else parent.removeChild(n);continue}
      var at=[];
      for(var j=0;j<n.attributes.length;j++)at.push(n.attributes[j]);
      for(var k=0;k<at.length;k++){
        var name=at[k].name.toLowerCase();
        if(!attrOk(tag,name,at[k].value)){n.removeAttribute(at[k].name);continue}
        if(name==='style'){var sc=cleanCss(at[k].value);if(sc)n.setAttribute('style',sc);else n.removeAttribute('style')}
      }
      if(tag==='a'){n.setAttribute('target','_blank');n.setAttribute('rel','noopener noreferrer')}
      // A picture whose source was taken out would draw a broken-image icon.
      if(tag==='img'&&!n.getAttribute('src')){parent.removeChild(n);continue}
      clean(n);
    }
  }
  function inlineHtml(html){
    if(RUNS.test(html))return null;
    var host=mk('div','ss-agent-html');
    if(!host.attachShadow)return null;
    var tpl=document.createElement('template');
    if(!tpl.content)return null;
    tpl.innerHTML=html;
    clean(tpl.content);
    var root=host.attachShadow({mode:'open'});
    var st=document.createElement('style');st.textContent=SHADOW;
    var box=document.createElement('div');box.className='ss-r';
    box.appendChild(document.importNode(tpl.content,true));
    root.appendChild(st);root.appendChild(box);
    return host;
  }

  // ---- Splitting a reply ------------------------------------------------------
  // Where a run of HTML that starts at start ends: the end of the line on which
  // its tags have all closed, unless the next line with words on it starts more
  // HTML (a <style> and the <div> it styles are one run).
  function lineEnd(s,i){var e=s.indexOf('\n',i);return e<0?s.length:e}
  function runEnd(s,start){
    var depth=0,i=start,n=s.length,low=null;
    for(;;){
      var lt=s.indexOf('<',i);
      if(depth<=0&&i>start){
        var eol=lineEnd(s,i);
        if(lt<0||lt>eol){
          var j=eol;
          while(j<n){var e=lineEnd(s,j+1);if(/\S/.test(s.slice(j+1,e)))break;j=e}
          if(j>=n||!START.test(s.slice(j+1,lineEnd(s,j+1))))return eol;
          i=j+1;continue;
        }
      }
      if(lt<0)return n;
      if(s.substr(lt,4)==='<!--'){var c=s.indexOf('-->',lt+4);i=c<0?n:c+3;continue}
      if(s.charAt(lt+1)==='!'){var g=s.indexOf('>',lt);i=g<0?n:g+1;continue}
      TAG.lastIndex=lt;
      var m=TAG.exec(s);
      if(!m){i=lt+1;continue}
      i=lt+m[0].length;
      var name=m[2].toLowerCase();
      if(m[1]){depth--;continue}
      if(VOID.test(name)||/\/\s*$/.test(m[3]))continue;
      if(RAWTEXT.test(name)){low=low||s.toLowerCase();var k=low.indexOf('</'+name,i);if(k<0)return n;var g2=s.indexOf('>',k);i=g2<0?n:g2+1;continue}
      depth++;
    }
  }
  function htmlRuns(s,out){
    var pos=0,i=0,n=s.length;
    while(i<n){
      var eol=lineEnd(s,i);
      if(START.test(s.slice(i,eol))){
        if(/\S/.test(s.slice(pos,i)))out.push({kind:'text',text:s.slice(pos,i)});
        var end=runEnd(s,i);
        if(end<=i)end=eol;
        out.push({kind:'flow',html:s.slice(i,end)});
        pos=i=end;
        continue;
      }
      i=eol+1;
    }
    if(/\S/.test(s.slice(pos)))out.push({kind:'text',text:s.slice(pos)});
  }
  function split(text){
    text=String(text||'');
    var out=[],last=0,m;
    FENCE.lastIndex=0;
    while((m=FENCE.exec(text))){
      if(m.index>last)htmlRuns(text.slice(last,m.index),out);
      var lang=m[1].toLowerCase();
      if(lang==='html'||lang==='svg')out.push({kind:'html',html:m[2]});
      else out.push({kind:'code',lang:lang,text:m[2]});
      last=m.index+m[0].length;
    }
    if(last<text.length)htmlRuns(text.slice(last),out);
    return out;
  }

  // ---- Words ------------------------------------------------------------------
  // [name](url) shows the name as the link; a bare URL shows itself. Only
  // http(s) targets, built as DOM.
  var LINK=/\[([^\]\n]{1,300})\]\((https?:\/\/(?:[^\s<>"()]|\([^\s<>"()]*\))+)\)|(https?:\/\/[^\s<>"')\]]+)/g;
  // One pass over a line: code, links, bold, strike, italic, and the inline
  // tags a model writes among words. Groups: 1 code · 2,3 named link · 4 bare
  // URL · 5,6 bold · 7 strike · 8,9 italic · 10,11 an inline tag and its
  // attributes (<br> matches with no group).
  var INLINE=/\x60([^\x60\n]+)\x60|\[([^\]\n]{1,300})\]\((https?:\/\/(?:[^\s<>"()]|\([^\s<>"()]*\))+)\)|(https?:\/\/[^\s<>"')\]]+)|\*\*(?=\S)([^\n]*?\S)\*\*|__(?=\S)([^\n]*?\S)__(?!\w)|~~(?=\S)([^\n]*?\S)~~|\*(?=[^\s*])([^*\n]*?[^\s*\\])\*(?![\w*])|_(?=[^\s_])([^_\n]*?[^\s_\\])_(?!\w)|<br\s*\/?>|<(b|strong|i|em|u|s|del|ins|code|kbd|mark|small|sub|sup|span|a)(\s(?:[^<>"']|"[^"]*"|'[^']*')*)?>/gi;
  function link(href,label){var a=mk('a');a.href=href;a.target='_blank';a.rel='noopener';if(label!=null)a.textContent=label;return a}
  function inline(node,text){
    var re=new RegExp(INLINE.source,'gi'),last=0,m;
    while((m=re.exec(text))){
      // _x_, __x__ and *x* only where a word doesn't run into them: snake_case
      // and 2*3*4 stay as written.
      if((m[6]!=null||m[8]!=null||m[9]!=null)&&/[\w*\\]/.test(text.charAt(m.index-1))){re.lastIndex=m.index+1;continue}
      if(m.index>last)node.appendChild(txt(ent(text.slice(last,m.index))));
      last=m.index+m[0].length;
      var el;
      if(m[1]!=null){el=mk('code');el.textContent=m[1]}
      else if(m[3]){el=link(m[3],m[2])}
      else if(m[4]){
        var u=m[4],tail=(/[.,;:!?]+$/.exec(u)||[''])[0];
        if(tail)u=u.slice(0,u.length-tail.length);
        node.appendChild(link(u,u));
        if(tail)node.appendChild(txt(tail));
        continue;
      }
      else if(m[5]!=null||m[6]!=null){el=mk('strong');inline(el,m[5]!=null?m[5]:m[6])}
      else if(m[7]!=null){el=mk('s');inline(el,m[7])}
      else if(m[8]!=null||m[9]!=null){el=mk('em');inline(el,m[8]!=null?m[8]:m[9])}
      else if(m[10]){
        // An inline tag counts only with its closing tag on the same line.
        var name=m[10].toLowerCase(),close=text.toLowerCase().indexOf('</'+name+'>',last);
        if(close<0){node.appendChild(txt(m[0]));continue}
        var inner=text.slice(last,close);
        last=close+name.length+3;
        if(name==='a'){
          var h=/\bhref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i.exec(m[11]||''),href=h?ent(h[1]||h[2]||h[3]||''):'';
          el=/^https?:\/\//i.test(href)?link(href):mk('span');
        }else el=mk(name);
        inline(el,inner);
      }
      else el=mk('br');
      node.appendChild(el);
    }
    if(last<text.length)node.appendChild(txt(ent(text.slice(last))));
  }
  // The linkify the page used before inline(): links only, everything else as typed.
  function linkify(node,text){
    text=String(text);
    var last=0,m;
    LINK.lastIndex=0;
    while((m=LINK.exec(text))){
      if(m.index>last)node.appendChild(txt(text.slice(last,m.index)));
      node.appendChild(link(m[2]||m[3],m[1]||m[3]));
      last=m.index+m[0].length;
    }
    if(last<text.length)node.appendChild(txt(text.slice(last)));
  }
  var ROW=/^\s*\|.*\|\s*$/,RULE=/^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/;
  function cells(line){var s=line.trim();if(s.charAt(0)==='|')s=s.slice(1);if(s.slice(-1)==='|')s=s.slice(0,-1);return s.split('|').map(function(c){return c.trim()})}
  function table(rows){
    var wrap=mk('div','ss-agent-table'),t=mk('table'),head=mk('thead'),body=mk('tbody'),tr=mk('tr');
    cells(rows[0]).forEach(function(c){var th=mk('th');inline(th,c);tr.appendChild(th)});
    head.appendChild(tr);
    rows.slice(2).forEach(function(r){var row=mk('tr');cells(r).forEach(function(c){var td=mk('td');inline(td,c);row.appendChild(td)});body.appendChild(row)});
    t.appendChild(head);t.appendChild(body);wrap.appendChild(t);
    return wrap;
  }
  function item(mark,rest,indent){
    var li=mk('div','ss-agent-li');
    if(indent)li.style.paddingLeft=Math.min(4,Math.ceil(indent/2))*1.1+'em';
    var k=mk('span','ss-agent-mark');k.textContent=mark;
    var body=mk('span','ss-agent-item');inline(body,rest);
    // The space is not drawn (a flex box skips it) but is copied: "• Kitchen log".
    li.appendChild(k);li.appendChild(txt(' '));li.appendChild(body);
    return li;
  }
  // Words: a line at a time, each its own element, so a list item wraps under
  // its own text and a blank line is a gap rather than a whole empty line.
  function words(t){
    var box=mk('div','ss-agent-text'),lines=t.split('\n'),gap=false,drawn=0;
    for(var i=0;i<lines.length;i++){
      var line=lines[i],m;
      if(!/\S/.test(line)){if(!gap&&drawn)box.appendChild(mk('div','ss-agent-gap'));gap=true;continue}
      gap=false;drawn++;
      if(ROW.test(line)&&i+1<lines.length&&RULE.test(lines[i+1])){
        var j=i+2;while(j<lines.length&&ROW.test(lines[j]))j++;
        box.appendChild(table(lines.slice(i,j)));i=j-1;continue;
      }
      if((m=/^\s*#{1,6}\s+(.*?)\s*#*\s*$/.exec(line))){var h=mk('div','ss-agent-h');inline(h,m[1]);box.appendChild(h);continue}
      if(/^\s*([-*_])(\s*\1){2,}\s*$/.test(line)){box.appendChild(mk('hr','ss-agent-hr'));continue}
      if((m=/^(\s*)[-*+•]\s+(.*)$/.exec(line))){box.appendChild(item('•',m[2],m[1].length));continue}
      if((m=/^(\s*)(\d{1,3}[.)])\s+(.*)$/.exec(line))){box.appendChild(item(m[2],m[3],m[1].length));continue}
      if((m=/^\s*>\s?(.*)$/.exec(line))){var q=mk('div','ss-agent-quote');inline(q,m[1]);box.appendChild(q);continue}
      var d=mk('div','ss-agent-line');inline(d,line);box.appendChild(d);
    }
    return box;
  }
  function code(t){var p=mk('pre','ss-agent-code');p.textContent=t;return p}

  // While a reply is still arriving (opts.live) it is drawn again on every delta:
  // HTML that only shows something is cheap to draw again, but a frame would load
  // a fresh document each time, so it waits as a line until the words stop.
  function wait(){var d=mk('div','ss-agent-wait');d.textContent='Drawing\u2026';return d}
  // Draws an agent reply into node.
  function render(node,text,opts){
    var live=!!(opts&&opts.live);
    node.textContent='';
    node.dataset.raw=text||'';
    split(String(text||'')).forEach(function(p){
      if(p.kind==='html'){node.appendChild(live?wait():block(p.html));return}
      if(p.kind==='flow'){node.appendChild(inlineHtml(p.html)||(live?wait():flow(p.html)));return}
      if(p.kind==='code'){node.appendChild(code(p.text));return}
      var t=p.text.replace(/^\s*\n|\n\s*$/g,'').replace(/^\n+|\n+$/g,'');
      if(!/\S/.test(t))return;
      node.appendChild(words(t));
    });
  }
  // One line of it (the conversation list). Mirrors agentReplyPreview().
  var TAGS_BLOCK=new RegExp('<\\/?(?:'+BLOCK+'|br)\\b[^<>]*>','gi');
  function preview(text){
    return String(text||'')
      .replace(HTMLFENCE,' ▦ visual ')
      .replace(/<(style|script)\b[\s\S]*?<\/\1\s*>/gi,' ')
      .replace(/<!--[\s\S]*?-->/g,' ')
      .replace(TAGS_BLOCK,' ')
      .replace(/<\/?[a-zA-Z][\w:-]*(?:\s[^<>]*)?>/g,'')
      .replace(LINK,function(m,name,url,bare){return name||bare})
      .replace(/\x60\x60\x60[\w+-]*/g,' ')
      .replace(/\*\*|__|~~|\x60/g,'')
      .replace(/^[ \t]*#{1,6}[ \t]+/gm,'')
      .replace(/^[ \t]*\|?[ \t]*:?-{2,}:?[ \t]*(\|[ \t]*:?-{2,}:?[ \t]*)*\|?[ \t]*$/gm,' ')
      .replace(/^[ \t]*>[ \t]?/gm,'')
      .replace(/[ \t]*\|[ \t]*/g,' ')
      .replace(/&nbsp;/g,' ').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#39;/g,"'").replace(/&amp;/g,'&')
      .replace(/\s+/g,' ').trim();
  }
  // Whether a reply has HTML that is drawn (a run of block tags, or an html card):
  // a surface that draws plain replies its own way hands only these to render().
  function rich(text){
    if(!/<[a-zA-Z!]/.test(String(text||''))&&!/\x60\x60\x60(?:html|svg)/i.test(String(text||'')))return false;
    return split(text).some(function(p){return p.kind==='flow'||p.kind==='html'});
  }
  // The words of a reply with its lines kept, for a copy or a line read out loud.
  // Mirrors agentReplyText().
  function plain(text){
    text=String(text||'');
    if(!/<(?:[a-zA-Z]|!--)/.test(text))return text;
    return text
      .replace(/<(style|script)\b[\s\S]*?<\/\1\s*>/gi,'')
      .replace(/<!--[\s\S]*?-->/g,'')
      .replace(/<\/t[dh]>\s*<t[dh]\b[^<>]*>/gi,' \u00b7 ')
      .replace(/<li\b[^<>]*>/gi,'\n\u2022 ')
      .replace(TAGS_BLOCK,'\n')
      .replace(/<\/?[a-zA-Z][\w:-]*(?:\s[^<>]*)?>/g,'')
      .replace(/&nbsp;/g,' ').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#39;/g,"'").replace(/&amp;/g,'&')
      .replace(/[ \t]+/g,' ')
      .replace(/ ?\n[ \n]*/g,'\n')
      .trim();
  }
  window.ssAgentReply={render:render,preview:preview,split:split,rich:rich,text:plain,linkify:linkify,safe:{css:cleanCss,attr:attrOk}};
})();